/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_0_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the ArtCraft project page and the storytold/gridcraft GitHub repository to identify the upstream software. The project publishes its source, release files and documentation there. This website adds a launch page and practical guides; it is not Microsoft Excel and is not the official ArtCraft website.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_0_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过 ArtCraft 项目页和 storytold/gridcraft GitHub 仓库，可以确认上游软件的身份。项目在那里发布源码、安装文件和文档。本网站提供启动页与实用指南，既不是 Microsoft Excel，也不是 ArtCraft 官方网站。`)
};

/**
* | output |
* | --- |
* | "Use the ArtCraft project page and the storytold/gridcraft GitHub repository to identify the upstream software. The project publishes its source, release file..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_0_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_0_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_0_paragraphs_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_0_paragraphs_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_0_paragraphs_0 as "gc.search_guides.what_is_gridcraft.sections.0.paragraphs.0" }